import { Tabs, TabList, Tab } from '@chakra-ui/react';
import { KText } from '../../text';

interface TabOption {
  id: string;
  label: string;
}

interface TabBarProps {
  options: TabOption[];
  selectedId: string;
  onChange: (id: string) => void;
  width?: string | number;
  tabBarStyles?: any;
  tabProps?: any;
  textProps?: any;
  selectedColor?: string;
}

export const TabBar: React.FC<TabBarProps> = ({
  options,
  selectedId,
  onChange,
  tabBarStyles,
  tabProps,
  textProps,
  selectedColor = 'primary-500',
}) => {
  const tabIndex = options.findIndex((option) => option.id === selectedId);

  const handleTabChange = (index: number) => {
    onChange(options[index].id);
  };

  return (
    <Tabs
      index={tabIndex}
      onChange={handleTabChange}
      variant="unstyled"
      isFitted
    >
      <TabList
        alignItems="center"
        borderRadius="sm"
        sx={{ border: '1px solid', borderColor: 'border-color' }}
        overflow="hidden"
        {...tabBarStyles}
      >
        {options.map((option, index) => {
          const isSelected = option.id === selectedId;
          return (
            <Tab
              key={option.id}
              flex={1}
              p="6px"
              borderRadius="0"
              bg={isSelected ? 'primary-100' : 'transparent'}
              _selected={{
                bg: 'primary-100',
              }}
              _active={{
                bg: isSelected ? 'primary-100' : 'transparent',
              }}
              _focus={{
                boxShadow: 'none',
              }}
              _hover={{
                bg: isSelected ? 'primary-100' : 'primary-50',
              }}
              borderLeft={index > 0 ? '1px solid' : 'none'}
              borderColor="border-color"
              transition="background 0.2s ease"
              {...tabProps}
            >
              <KText
                size="sm-medium"
                color={isSelected ? selectedColor : 'secondary-700'}
                {...textProps}
              >
                {option.label}
              </KText>
            </Tab>
          );
        })}
      </TabList>
    </Tabs>
  );
};

export default TabBar;
